<template>
    <div id="forgot-password" class="container">
        <div class="columns is-mobile">
            <div class="column is-10-mobile is-offset-1-mobile is-4-tablet is-offset-4-desktop">
                <div class="columns wrapper">
                    <div class="column is-12">
                        <div id="logo">
                            <img src="/images/dashboard/pasti-logo-big.svg">
                        </div>
                        <div class="title is-5 has-text-centered">
                            Reset Password
                        </div>

                        <!-- Forgot password form -->
                        <form id="forgot-password-form" data-vv-scope="forgot-password-form" v-on:submit.prevent>

                            <!-- Backend success and error message -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet">
                                    <!-- Display success message -->
                                    <div class="notification is-success" v-if="success_message">
                                        <button class="delete" @click="success_message = ''"></button>
                                        <p>{{ success_message }}</p>
                                    </div>

                                    <!-- Display error message -->
                                    <div class="notification is-danger" v-if="error_message">
                                        <button class="delete" @click="error_message = ''"></button>

                                        <p v-if="typeof error_message === 'string'">{{ error_message }}</p>
                                        <div class="content" v-else>
                                            <ul>
                                                <li v-for="(error, index) in error_message">{{ error }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Username text input -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet">
                                    <div class="field">
                                        <p class="control has-icons-right">
                                            <input v-model="email" v-validate="'required'" class="input" type="text"
                                                   name="email" placeholder="Email">

                                            <span v-show="errors.has('forgot-password-form.email')" class="icon is-small is-right">
                                                  <i class="fa fa-warning"></i>
                                                </span>

                                            <span class="help is-danger" v-show="errors.has('forgot-password-form.email')">
                                                {{ errors.first('forgot-password-form.email') }}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Submit button -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet has-text-centered">
                                    <button type="button" class="button submit-button" @click="validateForgotPasswordForm('forgot-password-form')">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>

                        <!-- Already have account link -->
                        <div class="columns">
                            <div class="column is-10 is-offset-1-tablet has-text-centered">
                                <div class="forgot-password title is-6">
                                    <a :href="login_url">Already have account?</a>
                                </div>
                            </div>
                        </div>

                        <!-- Google Play Badge -->
                        <div class="columns is-mobile download-app">
                            <div class="column is-6 is-offset-3">
                                <div class="columns is-mobile">
                                    <div class="column is-4">
                                        <p>Download our app</p>
                                    </div>
                                    <div class="column is-8">
                                        <img src="/images/dashboard/google-play-badge.png" class="img-responsive">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Copyright -->
                        <div class="columns">
                            <div class="column is-12">
                                <div class="copyright has-text-centered">
                                    Copyright © {{ current_year }} MyEG Servics Berhad. All Rights Reserved. Version 1.1
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const moment = require('moment');

    export default
    {
        props: {
            login_url: {
                type: String,
                required: true
            },
            send_reset_password_email_url: {
                type: String,
                required: true
            },
        },
        data: function() {
          return {
            email: '',
            success_message: '',
            error_message: '',
          }
        },
        watch: {
            success_message() {
                this.setClearTimeout('success');
            },
            error_message() {
                this.setClearTimeout('error');
            },
        },
        methods: {
            validateForgotPasswordForm(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        this.sendResetPasswordEmail();
                    }
                });
            },
            sendResetPasswordEmail: function()
            {
                let postData = {
                    email: this.email,
                };

                axios.post(this.send_reset_password_email_url, postData)
                    .then(response => {
                        let vm = this;

                        if (response.data.message !== undefined) {
                            vm.success_message = response.data.message;
                        }

                        if (response.data.error !== undefined) {
                            vm.error_message = response.data.error;
                        }
                    })
                    .then(() => {
                        this.errors.clear();
                    })
                    .catch(error => {
                        if (error.response !== undefined) {
                            // Display validation error messages.
                            if (error.response.status === 422) {
                                let errorMessage = [];

                                error.response.data.errors.foreach(function (item, key) {
                                    errorMessage.push(item[0]);
                                });

                                this.error_message = errorMessage;
                            }
                        }
                    })
            },
            clearMessage() {
                this.success_message = '';
            },
            setClearTimeout(message) {
                if (message == 'error') {
                        setTimeout(() => {
                        this.error_message = '';
                    }, 5000);
                } else {
                    setTimeout(() => {
                        this.success_message = '';
                    }, 5000);
                }

            }
        },
        computed: {
            moment: function() {
                return moment;
            },
            current_year: function() {
                return moment().utcOffset('+0800').year();
            }
        }
    }
</script>